export default "__VITE_ASSET__B7I1Io6k__"